import { FC, useState } from "react"
import { Plus } from "lucide-react"
import {
  useFindConnectorDetailsQuery,
  useFindConnectorsQuery
} from "../../../../redux/queries"
import { Brand } from "../../../../types"
import BrandAutocomplete from "../../brand-autocomplete"
import PrimaryBtn from "../../buttons/primary-btn"
import ConnectorsTable from "./table"
import ManageConnector from "./manage"

interface Props {
  brands: Brand[]
}

const ConfigConnectors: FC<Props> = ({ brands }) => {
  const [selectedBrandId, setSelectedBrandId] = useState<string>("")
  const [selectedConnectorId, setSelectedConnectorId] = useState<string>("")
  const [isCreating, setIsCreating] = useState<boolean>(false)

  const { data: connectors, isFetching } = useFindConnectorsQuery(
    { brand_id: selectedBrandId, active: undefined },
    { skip: !selectedBrandId }
  )

  const { data: connectorDetails } = useFindConnectorDetailsQuery(
    { id: selectedConnectorId },
    { skip: !selectedConnectorId }
  )

  const handleCreateNew = () => {
    setSelectedConnectorId("")
    setIsCreating(true)
  }

  const handleClose = () => {
    setSelectedConnectorId("")
    setIsCreating(false)
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <BrandAutocomplete
          brands={brands}
          selected={selectedBrandId}
          hideLabel
          onChange={setSelectedBrandId}
        />
        {selectedBrandId && (
          <PrimaryBtn onClick={handleCreateNew} className="flex items-center">
            <Plus size={16} className="mr-1" />
            Add New Connector
          </PrimaryBtn>
        )}
      </div>

      <div className="pt-6">
        {selectedBrandId ? (
          <ConnectorsTable
            data={connectors ?? []}
            isFetching={isFetching}
            onSelect={setSelectedConnectorId}
          />
        ) : null}
      </div>

      <ManageConnector
        key={isCreating ? "create" : selectedConnectorId}
        open={!!selectedConnectorId || isCreating}
        data={isCreating ? undefined : connectorDetails}
        brandId={selectedBrandId}
        onClose={handleClose}
      />
    </div>
  )
}

export default ConfigConnectors
